type Props = {
  id: string;
  category: string;
  headline: string;
  body: string;
  stat: { value: string; label: string };
};

export function CaseCard({ id, category, headline, body, stat }: Props) {
  return (
    <article className="group flex h-full flex-col gap-5 rounded-lg border border-rule bg-white p-8 transition-all hover:-translate-y-0.5 hover:border-cyan">
      <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-4">
        {id} · {category}
      </div>
      <h3 className="font-display text-xl leading-snug text-ink md:text-2xl">
        {headline}
      </h3>
      <p className="text-sm leading-relaxed text-ink-3">{body}</p>
      <div className="mt-auto border-t border-rule pt-5">
        <div className="font-display text-3xl text-cyan-deep">{stat.value}</div>
        <div className="mt-1 font-mono text-[11px] uppercase tracking-wider text-ink-4">
          {stat.label}
        </div>
      </div>
    </article>
  );
}
